module.exports = __webpack_public_path__ + "static/media/instamaps_small@2x.a63dd8f9.jpg";